import React from 'react';
import PropTypes from 'prop-types';
import IconShared from 'assets/inviteABite/iab-funnel-shared.svg';
import IconReviewed from 'assets/inviteABite/iab-funnel-reviewed.svg';
import IconFirstOrder from 'assets/inviteABite/iab-funnel-first-order.svg';
import {
  IABFunnelBar,
  IABFunnelBarFill,
  IABFunnelCard,
  IABFunnelCount,
  IABFunnelIcon,
  IABFunnelLabel,
  IABFunnelLabelRow,
  IABFunnelPercent,
  IABFunnelRow,
  IABFunnelSubtitle,
  IABFunnelTitle,
  IABFunnelValues
} from 'routes/App/inviteABite/ActiveState/styles';

const formatNumber = (value) =>
  new Intl.NumberFormat('en-GB', {maximumFractionDigits: 0}).format(
    Number(value || 0)
  );

const computePercent = (count, base) => {
  if (!base || base <= 0) return null;
  return Math.round((Number(count || 0) / Number(base)) * 100);
};

const ReferralFunnel = ({funnel}) => {
  const shared = Number(funnel?.shared || 0);
  const reviewed = Number(funnel?.viewed || 0);
  const firstOrder = Number(funnel?.firstOrder || 0);

  if (shared === 0 && reviewed === 0 && firstOrder === 0) {
    return null;
  }

  const stages = [
    {
      key: 'shared',
      label: 'Referral link shared',
      icon: IconShared,
      count: shared,
      percent: null,
      color: '#17C981'
    },
    {
      key: 'reviewed',
      label: 'Referral link reviewed',
      icon: IconReviewed,
      count: reviewed,
      percent: computePercent(reviewed, shared),
      color: '#4671DB'
    },
    {
      key: 'firstOrder',
      label: 'First order placed',
      icon: IconFirstOrder,
      count: firstOrder,
      percent: computePercent(firstOrder, shared),
      color: '#FF2D38'
    }
  ];

  const maxCount = Math.max(shared, reviewed, firstOrder);

  return (
    <IABFunnelCard>
      <IABFunnelTitle>Referral funnel</IABFunnelTitle>
      <IABFunnelSubtitle>From share to first order</IABFunnelSubtitle>
      {stages.map((stage) => {
        const fillPercent =
          maxCount > 0 ? Math.round((stage.count / maxCount) * 100) : 0;
        return (
          <IABFunnelRow key={stage.key}>
            <IABFunnelLabelRow>
              <IABFunnelIcon src={stage.icon} alt='' />
              <IABFunnelLabel>{stage.label}</IABFunnelLabel>
              <IABFunnelValues>
                {stage.percent !== null && (
                  <IABFunnelPercent>{stage.percent}%</IABFunnelPercent>
                )}
                <IABFunnelCount>{formatNumber(stage.count)}</IABFunnelCount>
              </IABFunnelValues>
            </IABFunnelLabelRow>
            <IABFunnelBar>
              <IABFunnelBarFill
                style={{width: `${fillPercent}%`, background: stage.color}}
              />
            </IABFunnelBar>
          </IABFunnelRow>
        );
      })}
    </IABFunnelCard>
  );
};

ReferralFunnel.propTypes = {
  funnel: PropTypes.shape({
    shared: PropTypes.number,
    viewed: PropTypes.number,
    firstOrder: PropTypes.number
  })
};

ReferralFunnel.defaultProps = {
  funnel: null
};

export default ReferralFunnel;
